import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/named_nouns.png'


const _hoisted_1 = { class: "max-w-lg mx-auto text-left p-2" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = { class: "flex-none w-32" }
const _hoisted_5 = { class: "flex-initial w-64" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-londrina" }, "Named Noun and Nouns Love", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "space-y-2 mb-8 font-pt-root font-medium" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("In order to make "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-londrina" }, "NounsFes"),
  /*#__PURE__*/_createTextVNode(" more attractive, we raised some money by selling "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opensea.io/collection/named-noun",
    class: "underline font-londrina"
  }, "Named Noun NFTs"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opensea.io/collection/nouns-love",
    class: "underline font-londrina"
  }, "Nouns Love NFTs"),
  /*#__PURE__*/_createTextVNode(" to supporters. ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Thanks to all the supporters, we were able to raise ")
const _hoisted_17 = { class: "font-londrina" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" so far. Thank you very much! ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-londrina" }, "Nouns Love NFT"),
  /*#__PURE__*/_createTextVNode(" is available at "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://nouns.love/",
    class: "underline font-londrina"
  }, "Nouns Love Auction Site.")
], -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "space-y-2 mb-8 font-pt-root font-medium" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-londrina" }, "Nouns Art Festival"),
  /*#__PURE__*/_createTextVNode("をより魅力的なものにするために、 "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opensea.io/collection/named-noun",
    class: "underline font-londrina"
  }, "Named Noun"),
  /*#__PURE__*/_createTextVNode("と "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://opensea.io/collection/nouns-love",
    class: "underline font-londrina"
  }, "Nouns Love"),
  /*#__PURE__*/_createTextVNode(" というNFTコレクションを、サポーターに販売するという形のクラウドファンディングを行っています。")
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("おかげさまで、現時点で、")
const _hoisted_24 = { class: "font-londrina" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" が集まっています。ありがとうございます！ ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-londrina" }, "Nouns Love NFT"),
  /*#__PURE__*/_createTextVNode(" は "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://nouns.love/ja",
    class: "underline font-londrina"
  }, "Nouns Love オークションサイト"),
  /*#__PURE__*/_createTextVNode("で入手が可能です。")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "mb-4",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.displayAccount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("message.walletId")), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.displayAccount), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.tokenGate == 'switchNetwork')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.nounsCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.youHaveNouns", { nounsCount: _ctx.nounsCount })), 1)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t("message.pleaseSwitchToPolygon")) + " ", 1),
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToPolygon && _ctx.switchToPolygon(...args))),
                    class: "underline"
                  }, _toDisplayString(_ctx.$t("menu.switch")), 1)
                ]))
          ]))
        : (_ctx.tokenGate == 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.namedNounCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.youHaveNFTs", { namedNounCount: _ctx.namedNounCount })), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("message."+_ctx.tokenGate)), 1)
            ]))
    ]),
    _hoisted_12,
    (_ctx.lang === 'en')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", null, [
              _hoisted_16,
              _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.raised_eth) + "ETH", 1),
              _hoisted_18
            ]),
            _hoisted_19
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("p", null, [
              _hoisted_23,
              _createElementVNode("b", _hoisted_24, _toDisplayString(_ctx.raised_eth) + "ETH", 1),
              _hoisted_25
            ]),
            _hoisted_26
          ])
        ])),
    _hoisted_27
  ]))
}